import React, { useState } from "react";

import env from "../../env";

import ErrorAction from "../../components/Modal/ErrorAction";

import PostReq from "../../utils/PostReq";

function CommentsTableRow(props) {
  const [statusPop, setStatusPop] = useState(false);
  const [homePop, setHomePop] = useState(false);
  const [replyDialog, setReplyDialog] = useState(false);
  const [replyText, setReplyText] = useState("");
  const [loading, setLoading] = useState(false);

  const activeAcc = props.index === props.detail;
  const item = props.item;

  // =========================
  // تغییر وضعیت کامنت
  // =========================
  const handleChangeStatus = async () => {
    try {
      setLoading(true);

      const result = await PostReq({
        method: "Post",
        url: "/panel/document/active-comment",
        body: {
          commentId: item._id,
          active: !item.active,
        },
      });

      if (result.success) {
        setStatusPop(false);
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // =========================
  // تغییر نمایش کامنت در صفحه اصلی
  // =========================
  const handleChangeInHome = async () => {
    try {
      setLoading(true);

      const result = await PostReq({
        method: "Post",
        url: "/panel/document/update-comment",
        body: {
          commentId: item._id,
          inHome: !item.inHome,
        },
      });

      if (result.success) {
        setHomePop(false);
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // =========================
  // پاسخ به کامنت
  // =========================
  const handleReply = async () => {
    if (!replyText.trim()) return;

    try {
      setLoading(true);

      const result = await PostReq({
        method: "Post",
        url: "/panel/document/update-comment",
        body: {
          commentId: item._id,
          reply: replyText.trim(),
        },
      });

      if (result.success) {
        setReplyDialog(false);
        setReplyText("");
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <tr className={activeAcc ? "activeAccordion" : "accordion"}>
        {/* محصول */}
        <td>
          <div className="cu-avatar" style={{ width: "auto" }}>
            <img
              src={
                item?.thumbUrl
                  ? env.siteApiUrl + item.thumbUrl
                  : env.defaultProduct
              }
              alt={item?.productTitle || "default"}
            />

            <div className="cu-name">
              <p className="name">{item?.productTitle}</p>
              <p className="email">{item?.sku}</p>
            </div>
          </div>
        </td>

        {/* نام کاربر */}
        <td>{item?.cName}</td>

        {/* متن کامنت */}
        <td
          style={{
            minWidth: "300px",
            textAlign: "right",
          }}
        >
          {item?.comment}
        </td>

        {/* وضعیت */}
        <td>
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "6px 14px",
              borderRadius: "6px",
              border: `1px solid ${item?.active ? "#198754" : "#dc3545"}`,
              color: item?.active ? "#198754" : "#dc3545",
              backgroundColor: item?.active
                ? "rgba(25, 135, 84, 0.08)"
                : "rgba(220, 53, 69, 0.08)",
              whiteSpace: "nowrap",
              fontSize: "13px",
            }}
          >
            {item?.active ? "تأیید شده" : "تأیید نشده"}
          </span>
        </td>

        {/* عملیات */}
        <td>
          <div
            className="more-btn"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: "8px",
              paddingInline: "1rem",
            }}
          >
            {/* تأیید / عدم تأیید */}
            <button
              type="button"
              disabled={loading}
              onClick={() => setStatusPop(true)}
              style={{
                border: `1px solid ${item?.active ? "#dc3545" : "#198754"}`,
                color: item?.active ? "#dc3545" : "#198754",
                background: "transparent",
                borderRadius: "6px",
                padding: "6px 12px",
                cursor: loading ? "not-allowed" : "pointer",
                whiteSpace: "nowrap",
              }}
            >
              {item?.active ? "عدم تأیید" : "تأیید"}
            </button>

            {/* نمایش / عدم نمایش در صفحه اصلی */}
            {!item.active ? (
              <></>
            ) : (
              <button
                type="button"
                disabled={loading}
                onClick={() => setHomePop(true)}
                style={{
                  border: `1px solid ${item?.inHome ? "#dc3545" : "#0d6efd"}`,
                  color: item?.inHome ? "#dc3545" : "#0d6efd",
                  background: "transparent",
                  borderRadius: "6px",
                  padding: "6px 12px",
                  cursor: loading ? "not-allowed" : "pointer",
                  whiteSpace: "nowrap",
                }}
              >
                {item?.inHome ? "حذف از صفحه اصلی" : "صفحه اصلی"}
              </button>
            )}

            {/* پاسخ */}
            <button
              type="button"
              disabled={loading}
              onClick={() => {
                setReplyDialog(true);
                setReplyText(item?.reply || "");
              }}
              style={{
                border: "1px solid #0d6efd",
                color: "#0d6efd",
                background: "transparent",
                borderRadius: "6px",
                padding: "6px 12px",
                cursor: loading ? "not-allowed" : "pointer",
              }}
            >
              پاسخ
            </button>
          </div>
        </td>
      </tr>

      {/* =========================
          دیالوگ تأیید / عدم تأیید
         ========================= */}
      {statusPop && (
        <ErrorAction
          text={
            item?.active
              ? "آیا از عدم تأیید این کامنت مطمئن هستید؟"
              : "آیا از تأیید این کامنت مطمئن هستید؟"
          }
          buttonText="بله"
          color={item?.active ? "red" : "green"}
          close={() => setStatusPop(false)}
          action={handleChangeStatus}
        />
      )}

      {/* =========================
          دیالوگ صفحه اصلی
         ========================= */}
      {homePop && (
        <ErrorAction
          text={
            item?.inHome
              ? "آیا از حذف این کامنت از صفحه اصلی مطمئن هستید؟"
              : "آیا می‌خواهید این کامنت در صفحه اصلی نمایش داده شود؟"
          }
          buttonText="بله"
          color={item?.inHome ? "red" : "green"}
          close={() => setHomePop(false)}
          action={handleChangeInHome}
        />
      )}

      {/* =========================
          دیالوگ پاسخ
         ========================= */}
      {replyDialog && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            direction: "rtl",
          }}
        >
          <div
            style={{
              width: "500px",
              maxWidth: "90%",
              background: "#fff",
              borderRadius: "10px",
              padding: "24px",
            }}
          >
            <h3
              style={{
                margin: "0 0 15px",
                fontSize: "18px",
              }}
            >
              پاسخ به کامنت
            </h3>

            {/* متن کامنت */}
            <div
              style={{
                background: "#f7f7f7",
                border: "1px solid #e5e5e5",
                borderRadius: "6px",
                padding: "12px",
                marginBottom: "15px",
                lineHeight: "1.8",
              }}
            >
              {item?.comment}
            </div>

            {/* پاسخ */}
            <textarea
              value={replyText}
              onChange={(e) => setReplyText(e.target.value)}
              placeholder="پاسخ خود را وارد کنید..."
              disabled={loading}
              style={{
                width: "100%",
                minHeight: "130px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "6px",
                resize: "vertical",
                outline: "none",
                direction: "rtl",
                boxSizing: "border-box",
              }}
            />

            {/* دکمه‌ها */}
            <div
              style={{
                display: "flex",
                gap: "10px",
                marginTop: "15px",
              }}
            >
              <button
                type="button"
                onClick={handleReply}
                disabled={loading || !replyText.trim()}
                style={{
                  border: "none",
                  background: "#0d6efd",
                  color: "#fff",
                  borderRadius: "6px",
                  padding: "8px 20px",
                  cursor:
                    loading || !replyText.trim() ? "not-allowed" : "pointer",
                }}
              >
                {loading ? "در حال ارسال..." : "ارسال پاسخ"}
              </button>

              <button
                type="button"
                disabled={loading}
                onClick={() => {
                  setReplyDialog(false);
                  setReplyText("");
                }}
                style={{
                  border: "1px solid #ddd",
                  background: "#fff",
                  borderRadius: "6px",
                  padding: "8px 20px",
                  cursor: "pointer",
                }}
              >
                انصراف
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CommentsTableRow;
